// extracted by mini-css-extract-plugin
export var icon = "_9c-3";
export var subtitle = "_9c-2";
export var title = "_9c-1";
export var value = "_9c-0";